import { formatUsername } from "discourse/lib/utilities";

export default formatUsername;
